import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, postData } from "src/utils/axios/serverHelper";

import {
	TQC3010_R01DetailDto,
	TQC3010_R01Dto,
	TQC3010_R01HeaderDto,
} from "./Dto_TQC3010_R01";

const baseUrl = `${config.apiUrl}/TQC3010_R01`;

export interface TQC3010_R01Params {
	compCd?: string;
	startDate?: string;
	endDate?: string;
	customCd?: string;
	itemCd?: string;
}

export interface TQC3010_R01DetailParams {
	itemCd: string;
	inspectNo?: string;
}

export const getTQC3010_R01List = async (
	option: string,
	params: TQC3010_R01Params,
) => getData<ResponseDto<TQC3010_R01HeaderDto[]>>(`${baseUrl}/${option}`, { params });

export const getTQC3010_R01AllCount = async (params: TQC3010_R01Params) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params });

export const getTQC3010_R01Detail = async (params: TQC3010_R01DetailParams) =>
	getData<ResponseDto<TQC3010_R01DetailDto[]>>(`${baseUrl}/detail`, { params });

export const saveTQC3010_R01 = async (payload: TQC3010_R01Dto) =>
	postData<TQC3010_R01Dto, ResponseDto<number>>(`${baseUrl}/save`, payload);

export const deleteTQC3010_R01 = async (list: TQC3010_R01HeaderDto[]) =>
	postData<TQC3010_R01HeaderDto[], ResponseDto<number>>(`${baseUrl}/delete`, list);

export const downloadExcel_TQC3010_R01 = async (params: TQC3010_R01Params) =>
	getData<ResponseDto<string>>(`${baseUrl}/excel`, { params });

/** 출하검사 성적서 및 일지 PDF — 제품·수요자별로 장이 나뉘며 한 장에 출하 8건이 들어간다 */
export const downloadReportPdf_TQC3010_R01 = async (params: TQC3010_R01Params) =>
	getData<Blob>(`${baseUrl}/report/pdf`, {
		params,
		responseType: "blob",
		headers: { Accept: "application/pdf" },
	});
